import { Scale, Subtract, Total } from "@pdfking/math"
import { HorizontalAlign } from "@pdfking/renderer-api"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { MonthName } from "../MonthName"
import { PictureCover } from "../PictureCover"

// A list of days' share of the frame's width, and its gap to the picture in
// the short side's
const LIST = 0.11
const GAP = 0.035

/** Akindez, a landscape desk calendar: the year low on the left of its
 * picture; a month's picture in the middle of the frame, its name on it, its
 * days in a narrow list either side, a little off it. */
export const Akindez: CalendarDesign = {
  cover: PictureCover({ align: HorizontalAlign.LEFT, at: 0.1, size: 0.18 }),
  page: ({ language, outer, short, year }, month) => {
    const list = Scale(outer.width, LIST)
    const gap = Scale(short, GAP)
    const [left, rest] = Slice.left(outer, list, gap)
    const [right, picture] = Slice.right(rest, list, gap)
    const inset = Scale(short, 0.04)
    return [
      Area.titled(
        picture,
        month,
        {
          height: Scale(short, 0.08),
          width: Subtract(picture.width, Scale(inset, 2)),
          x: Total(picture.x, inset),
          y: Subtract(Total(picture.y, picture.height), Total(inset, Scale(short, 0.08))),
        },
        MonthName(month, language).toUpperCase(),
        HorizontalAlign.LEFT
      ),
      Area.days(left, month, year, 1, 16),
      // as many rows as the left, level with them
      Area.days(right, month, year, 17, 32),
    ]
  },
  pages: "month",
}
